import IdentificationError from './IdentificationError';
class INEFileExtensionIsInvalid extends IdentificationError {
    constructor(section, options) {
        super(`INE ${section} file extension is invalid`, options);
    }
}
export default INEFileExtensionIsInvalid;
